/* ============================================================
   cart-kaartje-warn.js
   ------------------------------------------------------------
   Voegt extra kaartje(s) toe aan de cart wanneer de gebruiker op
   de "Kaartje toevoegen" knop klikt — wordt getoond als het aantal
   kaartjes lager is dan het aantal hoofdproducten in een bundle.
   ============================================================ */
(function () {
  'use strict';

  var pending = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-kaartje-warn__btn');
    if (!btn || pending) return;

    e.preventDefault();
    var bundleKey = btn.dataset.bundleKey;
    var variantId = parseInt(btn.dataset.kaartjeVariantId, 10);
    var tekort = parseInt(btn.dataset.tekort, 10) || 1;

    if (!variantId || !bundleKey) {
      console.warn('[SG] Kaartje-warn: missende data-attributes');
      return;
    }

    pending = true;
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Bezig met toevoegen…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: tekort,
            properties: { _kaartje_voor: bundleKey },
          },
        ],
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function () {
        /* Trigger Dawn's cart update zodat de cart-pagina + drawer
           hun secties opnieuw fetchen. We publiceren met een eigen
           source zodat alle subscribers reageren. */
        if (window.PUB_SUB_EVENTS && window.publish) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-kaartje-warn',
          });
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('[SG] Kaartje toevoegen mislukt:', err);
        btn.disabled = false;
        btn.textContent = origText;
        pending = false;
      });
  });
}());
